import lazyWithRetry from "@/utils/lazyWithRetry"

// Lazy load major feature components for route-based code splitting.
// Uses lazyWithRetry to handle stale chunk 404s after deployments —
// retries the import and falls back to a full page reload if needed.
export const LazyUnifiedDashboard = lazyWithRetry(() =>
  import("@/features/dashboard").then((module) => ({
    default: module.UnifiedDashboard,
  })),
)

export const LazyParentDashboard = lazyWithRetry(() =>
  import("@/pages/ParentDashboard").then((module) => ({
    default: module.default,
  })),
)

export const LazyHealthDashboard = lazyWithRetry(() =>
  import("@/features/admin/components/HealthDashboard").then((module) => ({
    default: module.default,
  })),
)

export const LazyFileManager = lazyWithRetry(() =>
  import("@/features/file-manager").then((module) => ({
    default: module.FileManager,
  })),
)

export const LazyPasswordChangeForm = lazyWithRetry(() =>
  import("@/features/profile").then((module) => ({
    default: module.PasswordChangeForm,
  })),
)

export const LazyUserInformation = lazyWithRetry(() =>
  import("@/features/user-settings").then((module) => ({
    default: module.UserInformation,
  })),
)

export const LazyRegisterForm = lazyWithRetry(() =>
  import("@/features/auth").then((module) => ({
    default: module.RegisterForm,
  })),
)

export const LazyPendingHouseholds = lazyWithRetry(() =>
  import("@/features/pending").then((module) => ({
    default: module.PendingHouseholds,
  })),
)

export const LazyPendingSessions = lazyWithRetry(() =>
  import("@/features/pending").then((module) => ({
    default: module.PendingSessions,
  })),
)

export const LazyPendingClassTemplates = lazyWithRetry(() =>
  import("@/features/pending").then((module) => ({
    default: module.PendingClassTemplates,
  })),
)

export const LazyPendingStudents = lazyWithRetry(() =>
  import("@/features/pending").then((module) => ({
    default: module.PendingStudents,
  })),
)

export const LazyPendingEnrollments = lazyWithRetry(() =>
  import("@/features/pending").then((module) => ({
    default: module.PendingEnrollments,
  })),
)

export const LazyPendingClassSessions = lazyWithRetry(() =>
  import("@/features/pending").then((module) => ({
    default: module.PendingClassSessions,
  })),
)

export const LazyPendingAttendances = lazyWithRetry(() =>
  import("@/features/pending").then((module) => ({
    default: module.PendingAttendances,
  })),
)
